import type { JsonObject, JsonValue } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";

export const AGENT_FORM_INPUT_VALUE_MAX_CHARACTERS = 500;

export function truncateAgentFormInputValues(inputs: JsonObject): JsonObject {
	return truncateJsonObject(inputs);
}

function truncateJsonValue(value: JsonValue): JsonValue {
	if (typeof value === "string") {
		return truncateStringValue(value);
	}
	if (Array.isArray(value)) {
		return value.map(truncateJsonValue);
	}
	if (value !== null && typeof value === "object") {
		return truncateJsonObject(value);
	}
	return value;
}

function truncateJsonObject(value: JsonObject): JsonObject {
	const result: JsonObject = {};
	for (const [key, entryValue] of Object.entries(value)) {
		result[key] = truncateJsonValue(entryValue);
	}
	return result;
}

function truncateStringValue(value: string): string {
	if (value.length <= AGENT_FORM_INPUT_VALUE_MAX_CHARACTERS) return value;
	const prefix = value.slice(0, validTruncationEndIndex(value, AGENT_FORM_INPUT_VALUE_MAX_CHARACTERS));
	return `${prefix} [TRUNCATED from ${value.length} characters]`;
}

function validTruncationEndIndex(value: string, endIndex: number): number {
	const lastIncludedCodeUnit = value.charCodeAt(endIndex - 1);
	const nextCodeUnit = value.charCodeAt(endIndex);
	if (isHighSurrogate(lastIncludedCodeUnit) && isLowSurrogate(nextCodeUnit)) {
		return endIndex - 1;
	}
	return endIndex;
}

function isHighSurrogate(codeUnit: number): boolean {
	return codeUnit >= 0xd800 && codeUnit <= 0xdbff;
}

function isLowSurrogate(codeUnit: number): boolean {
	return codeUnit >= 0xdc00 && codeUnit <= 0xdfff;
}
